import { render, staticRenderFns } from "./ZappingRoutineDetail.vue?vue&type=template&id=182b384c&scoped=true"
import script from "./ZappingRoutineDetail.vue?vue&type=script&lang=js"
export * from "./ZappingRoutineDetail.vue?vue&type=script&lang=js"
import style0 from "./ZappingRoutineDetail.vue?vue&type=style&index=0&id=182b384c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b384c",
  null
  
)

export default component.exports